import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { purgeStoredState } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { history } from "../../history";
import { clearCacheData } from "../../utility/Utils";
import { API_BASE_URL } from "./../../apis/common";

const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER;
const LOGOUTURL = `${API_BASE_URL}/logout`;
const initialState = {
  is_authenticated: false,
  data: {},
  check: true,
  userRole: "admin",
  accessToken: "",
  refreshToken: "",
  authLoading: false,
  buildVersion: BUILD_NUMBER,
  emailSent2FA: false,
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    login(state, _) {
      state.authLoading = true;
      //console.log("inside login reducer");
    },
    loginSuccess(state, action) {
      const data = action.payload;
      state.authLoading = false;
      state.data = data;
      state.token = data.login_auth;

      state.is_authenticated = true;
      state.user_guid = data.user_guid;
      state.login_by = data.login_by;
      state.user_role = data.user_role;
      if (data.user_role !== "OFFSITE") {
        state.location_id = data.locationRolesData_arr[0].location_id;
        state.location_name = data.locationRolesData_arr[0].location_name;
        state.location_address = data.locationRolesData_arr[0].location_address;
      }

      // console.log('loginSuccess data location -->',data.locationRolesData_arr[0].location_id)

      // state.accessToken = tokens.access.token;
      // state.refreshToken = tokens.refresh.token;
    },
    loginError(state, action) {
      console.log("naresh loginError");
      const { message = "Something went wrong, please try again" } =
        action.payload;
      state.authLoading = false;
      state.is_authenticated = false;
      state.accessToken = "";
      state.refreshToken = "";
      toast.error(message);
    },
    forgotPassword(state, _) {
      state.authLoading = true;
    },
    forgotPasswordSuccess(state, { payload }) {
      const { message } = payload;
      toast.success(message);
      state.authLoading = false;
    },
    forgotPasswordError(state, { payload }) {
      const { message } = payload;
      toast.error(message);
      state.authLoading = false;
    },

    setLocation(state, { payload }) {
      const { location_id, location_name, location_address } = payload;
      state.location_id = location_id;
      state.location_name = location_name;
      state.location_address = location_address;
    },
    setLocationName(state, { payload }) {
      const { location_name, location_address } = payload;
      state.location_name = location_name;
      state.location_address = location_address;
    },

    setDealership(state, { payload }) {
      const { id, name, address } = payload;
      state.dealership_id = id;
      state.dealership_name = name;
      state.dealership_address = address;
    },

    refreshToken(state, _) {
      state.authLoading = true;
    },

    refreshTokenSuccess(state, action) {
      const { payload: data } = action;
      state.authLoading = false;
      state.data = data;
      state.token = data.login_auth;

      state.user_guid = data.user_guid;
      state.login_by = data.login_by;

      // state.location_id = data.locationRolesData_arr[0].location_id;
      // state.location_name = data.locationRolesData_arr[0].location_name;
      state.is_authenticated = true;
    },
    refreshTokenError(state, { payload }) {
      console.log("naresh refreshTokenError");
      const { message } = payload;
      toast.error(message);
      state.authLoading = false;
      state.data = {};
      state.is_authenticated = false;
      state.user_guid = "";
      state.accessToken = "";
      state.refreshToken = "";
      // clearing the token
      state.token = "";
    },

    logout(state, _) {
      state.authLoading = true;
    },
    logoutSuccess(state, _) {
      console.log("naresh logoutSuccess");
      state.authLoading = false;
      state.data = {};
      state.is_authenticated = false;
      state.accessToken = "";
      state.refreshToken = "";
      state.token = "";
      state.location_id = "";
      state.location_name = "";
      state.location_address = "";
      state.emailSent2FA = false;
      state.dealership_id = "";

      purgeStoredState({ key: "auth", storage });
      window.location.reload(true);
    },
    logoutError(state, action) {
      const { message = "Something went wrong, please try again" } =
        action.payload;
      toast.error(message);
      state.authLoading = false;
      console.log("naresh logoutError");
      state.is_authenticated = false;
      state.accessToken = "";
      state.refreshToken = "";
    },
    changeProfilePic(state, action) {
      state.data.profile_pic = action.payload;
    },
    signout(state, _) {
      console.log("naresh signout");
      state.is_authenticated = false;
    },

    //Email send for 2FA Start
    emailSend2FA(state, _) {
      state.authLoading = true;
    },
    emailSend2FASuccess(state, _) {
      const message =
        "2FA code has been sent successfully, please check your inbox.";
      toast.success(message);
      state.authLoading = false;
      state.emailSent2FA = true;
      //history.push("/login");
    },
    emailSend2FAError(state, action) {
      const { message = "Something went wrong, please try again." } =
        action.payload;
      toast.error(message);
      state.authLoading = false;
      state.emailSent2FA = false;
    },

    setEmailSent2FA(state, { payload }) {
      const { emailSent2FA } = payload;
      state.emailSent2FA = emailSent2FA;
    },
    //Email send for 2FA End
  },
  extraReducers: {},
});

export const {
  changeProfilePic,
  signout,
  login,
  loginSuccess,
  loginError,
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordError,
  refreshToken,
  setLocation,
  setLocationName,
  refreshTokenSuccess,
  refreshTokenError,
  logout,
  logoutSuccess,
  logoutError,

  emailSend2FA,
  emailSend2FASuccess,
  emailSend2FAError,

  emailSent2FA,
  setEmailSent2FA,

  // new offsite wrok
  setDealership,
} = authenticationSlice.actions;

// selectors
export const selectAuthLoading = (state) => state.authentication.authLoading;
export const selectIsAuthenticated = (state) =>
  state.authentication.is_authenticated;
export const selectStoreId = (state) =>
  state.authentication.data?.store_id?._id;
export const selectUserId = (state) => state.authentication.data?.user_id;
export const selectRefreshToken = (state) => state.authentication.refreshToken;
export const selectAccessToken = (state) => state.authentication.accessToken;
export const selectBuildVersion = (state) => state.authentication.buildVersion;
export const selectToken = (state) => state.authentication.token;
export const selectLocationId = (state) => state.authentication.location_id;
export const selectLocationName = (state) => state.authentication.location_name;
export const selectLocationAddress = (state) =>
  state.authentication.location_address;

export const selectUserData = (state) => state.authentication.data;
export const selectEmailSent2FA = (state) => state.authentication.emailSent2FA;

export const selectUserGuid = (state) => state.authentication.user_guid;
export const selectLoginBy = (state) => state.authentication.login_by;

// offsite work
export const selectUserRole = (state) => state.authentication.user_role;
export const selectDealershipId = (state) => state.authentication.dealership_id;
export const selectDealershipName = (state) =>
  state.authentication.dealership_name;
export const selectDealershipAddress = (state) =>
  state.authentication.dealership_address;

export default authenticationSlice.reducer;
